import * as React from 'react'
import PrivateLayout from '$views/components/Layout/PrivateLayout'
import { FormContainer } from '$views/components/FormContainer'
import { Text, Block, Button } from '$views/components'
import { LocationInput } from '$views/components/Forms/LocationInput'
import {
  validateAddress,
  validateCheckoutForm,
} from '$views/LongTermRecommendation/CheckoutForm/CheckoutForm.validator'
import { DatepickerField } from '$views/LongTermRecommendation/CheckoutForm/components/DatepickerField'
import { draft } from '$utils/services/formDraftService'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { urlParamsParser } from '$infrastructure/utils/urlParamsParser'

export const checkoutFormDraftName = 'checkoutForm'
export const locationCheckoutField = 'location'
export const dateCheckoutField = 'dates'

interface Props {
  caretakerId: string
}

export const CheckoutForm: React.FC<Props> = ({ caretakerId }) => {
  const [address, setAddress] = React.useState<string>('')
  const [activeValidator, setActiveValidator] = React.useState<boolean>(false)

  const updateAddressForValidation = updateAddress => setAddress(updateAddress)

  const getRequestId = () => {
    const urlParam = urlParamsParser(location.search) as {
      requestId: string
    }

    return urlParam.requestId
  }

  const onClick = () => {
    const draftValues = draft.get(checkoutFormDraftName)

    setActiveValidator(true)
    if (draftValues && validateCheckoutForm(address, draftValues[dateCheckoutField])) {
      history.push(routeProvider.checkoutPayment(caretakerId, getRequestId()))
    }
  }

  return (
    <PrivateLayout secondLevel>
      <FormContainer login>
        <Text header>Reservar unas horas</Text>
        <Text marginTop="base">Indica los detalles de la reserva.</Text>
        <Text marginTop="small" subheader weight="medium">
          Dónde
        </Text>
        <LocationInput
          draftName={checkoutFormDraftName}
          draftPropertyName={locationCheckoutField}
          errorText={activeValidator ? validateAddress(address) : undefined}
          updateAddressForExternalValidation={updateAddress => updateAddressForValidation(updateAddress)}
        />
        <Text marginTop="small" subheader weight="medium">
          Cuándo
        </Text>
        <Text marginBottom="mini" marginTop="base">
          Selecciona el día y el horario de la reserva.
        </Text>
        <DatepickerField
          draftName={checkoutFormDraftName}
          draftPropertyName={dateCheckoutField}
          activeValidator={activeValidator}
        />
        <Block marginTop="small">
          <Button primary type="submit" onClick={onClick}>
            Siguiente
          </Button>
        </Block>
      </FormContainer>
    </PrivateLayout>
  )
}



// WEBPACK FOOTER //
// ./src/views/LongTermRecommendation/CheckoutForm/CheckoutForm.tsx